// Activation of the sending message with success
$(document).on("click",".contact .form-group-btn .btn",function(e){
});
